module.exports = ".sale-report-card p {\n  color: #212529;\n}\n.progress-status p {\n  margin-bottom: 0;\n}\n.week-status-card {\n  text-align: left;\n}\n.week-status-card .sale-rate {\n  font-size: 30px;\n  font-weight: 600;\n  position: absolute;\n  top: 15px;\n  right: 20px;\n}\n.week-status-card .card-body-main {\n  padding-bottom: 30px;\n}\n#campaignForm {\n  padding: 15px 0;\n}\n.input-group-prepend {\n  height: 100%;\n}\nth, td{\n  white-space: initial !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/campaigns/campaigns.component.css
// module id = ./src/app/components/campaigns/campaigns.component.css
// module chunks = main